<template>
  <!-- <v-menu
    v-model="selectedOpen"
    :close-on-content-click="false"
    :activator="selectedElement"
    offset-x
    transition="slide-x-transition"
    max-width="500px"
    min-width="350px"
  >-->
  <v-card
    color="white"
    class="grey--text"
    min-width="350px"
    min-height="100px"
    max-width="450px"
    flat
    v-if="isCreate"
  >
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title class="overline font-weight-medium"></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-content-save</v-icon>
      </v-btn>-->
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
      <v-btn icon @click="closeCard()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <!-- <v-icon>mdi-phone</v-icon> -->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            <slot name="title" v-bind:event="defaultEvent">
              <v-text-field
                v-model="defaultEvent.title"
                name="event-title"
                label
                filled
                :autocomplete="false"
                class="text-lowercase font-weight-regular title grey--text text--darken-2 pa-0 ma-0"
                :placeholder="
                  `Add ${buttons[type].text} title ${
                    type == 0 ? 'and date' : ''
                  }`
                "
                :autofocus="true"
                id="event-title"
                hide-details
                single-line
              ></v-text-field>
            </slot>
          </v-list-item-title>
          <v-list-item-subtitle class>
            <v-btn-toggle
              v-model="type"
              borderless
              mandatory
              color="primary"
              group
            >
              <v-btn
                v-for="(option, i) in buttons"
                :key="i"
                :value="option.value"
                small
                class="text-capitalize ml-0"
                v-text="option.text"
              ></v-btn>
            </v-btn-toggle>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense class="small-height">
        <v-list-item-avatar>
          <v-icon>mdi-clock-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize subtitle-2 font-weight-regular mb-0 grey--text text--lighten-3"
          >
            <v-btn small text>{{
              dateFormat(clientEvent.date, 'UTC:mmm d, yyyy')
            }}</v-btn>
            <v-btn small text class v-if="time">{{ clientEvent.time }}</v-btn>
            <span class="subtitle-2">-</span>
            <v-btn small text class v-if="time">{{ clientEvent.time }}</v-btn>
            <v-btn small text>{{
              dateFormat(clientEvent.date, 'UTC:mmm d, yyyy')
            }}</v-btn>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="!time">
          <v-btn outlined x-small @click="time = true">add time</v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-list-item dense class="small-height">
        <v-list-item-avatar>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize subtitle-2 font-weight-regular mb-0"
          >
            <v-autocomplete
              v-model="defaultEvent.participants"
              :items="participants"
              :search-input.sync="searchParticipants"
              hide-no-data
              hide-selected
              return-object
              cache-items
              multiple
              item-text="first_name"
              item-value="id"
              chips
              hide-details
              single-line
              placeholder="Start typing to Search"
              required
            >
              <!-- <template v-slot:item="data">
                <v-list-item @click="getSeletedData(data.item)">
                  <v-list-item-action>
                    <v-icon>{{ ICONS[data.item.type] }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>-->
            </v-autocomplete>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-show="show"></v-divider>
      <v-list-item dense class="small-height" @click.native="show = true">
        <v-list-item-avatar>
          <v-icon>mdi-text</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize subtitle-2 font-weight-regular mb-0"
          >
            <slot name="description" v-bind:event="defaultEvent">
              <v-textarea
                v-model="defaultEvent.description"
                name="event-description"
                label
                :autocomplete="false"
                class="text-capitalize font-weight-regular grey--text text--darken-2 pa-0 ma-0"
                placeholder="Add description"
                id="event-description"
                hide-details
                single-line
                rows="1"
              ></v-textarea>
            </slot>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-expand-transition>
        <v-list-item dense class="small-height" v-show="show">
          <v-list-item-avatar>
            <v-icon>mdi-text</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="text-capitalize subtitle-2 font-weight-regular mb-0"
            >
              <slot name="description" v-bind:event="defaultEvent">
                <v-textarea
                  v-model="defaultEvent.description"
                  name="event-description"
                  label
                  :autocomplete="false"
                  class="text-capitalize font-weight-regular grey--text text--darken-2 pa-0 ma-0"
                  placeholder="Add description"
                  id="event-description"
                  hide-details
                  single-line
                  rows="1"
                ></v-textarea>
              </slot>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-expand-transition>
      <v-divider v-show="show"></v-divider>
    </v-list>

    <v-card-actions>
      <!-- <v-btn icon>
        <v-icon>{{ show ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
      </v-btn>-->
      <v-spacer></v-spacer>
      <v-btn text class="grey--text text--darken-3 text-capitalize"
        >more options</v-btn
      >
      <v-btn color="primary" class="text-capitalize">save</v-btn>
    </v-card-actions>
  </v-card>

  <!-- DIVIDER CREATE EVENT -->

  <v-card
    color="white"
    class="grey--text"
    min-width="350px"
    min-height="100px"
    max-width="430px"
    flat
    v-else-if="!isCreate"
  >
    <v-toolbar
      color="transparent"
      dense
      flat
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-toolbar-title
        class="overline font-weight-medium"
        v-text="selectedEvent.type ? selectedEvent.type : selectedEvent.title"
      ></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="routeTo(selectedEvent)">
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
      <v-btn icon @click="deleteEvent(selectedEvent)">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-email-outline</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
      <v-btn icon @click="closeCard()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-list subheader class="py-0">
        <v-list-item three-line>
          <v-list-item-avatar>
            <v-icon small :class="`${selectedEvent.color}--text`"
              >mdi-solid</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="title font-weight-regular mb-0"
              v-text="
                selectedEvent.title
                  ? upperFirst(selectedEvent.title)
                  : '(no title)'
              "
            ></v-list-item-title>
            <v-list-item-subtitle class="grey--text text--darken-3">
              <span
                >{{
                  dateFormat(selectedEvent.start, 'dddd, mmmm dd')
                }}&nbsp;</span
              >
              <span class="text-lowercase">{{
                dateFormat(selectedEvent.start, 'h:MMTT') +
                  ' - ' +
                  dateFormat(selectedEvent.end, 'h:MMTT')
              }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="grey--text text--darken-3"
              >{{ frequencyToLabel[selectedEvent.frequency] }} till
              {{
                dateFormat(selectedEvent.recurrence_end, 'mmmm dd, yyyy')
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item dense class="small-height">
          <v-list-item-avatar>
            <v-icon>mdi-phone</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="text-capitalize subtitle-2 font-weight-medium primary--text mb-0"
              v-text="'phone number'"
            ></v-list-item-title>
            <v-list-item-subtitle class="caption grey--text text--darken-3">
              <span id="tel">
                <a href="tel:+1 234-567-8910">+1 234-567-8910</a> ‬ </span
              >&nbsp;
              <span id="pin">PIN: ‪123 456 789‬#</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-group no-action value="true" class="pa-0">
          <template v-slot:activator>
            <v-list-item dense class="small-height pa-0">
              <v-list-item-avatar>
                <v-icon color="grey darken-2"
                  >mdi-account-multiple-outline</v-icon
                >
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="text-capitalize subtitle-2 font-weight-regular mb-0"
                  v-text="
                    [...selectedEvent.participants, selectedEvent.creator]
                      .length + ' guests'
                  "
                ></v-list-item-title>
                <v-list-item-subtitle class="caption grey--text text--darken-3">
                  <span id="guest-confirm">1 awaiting confirmation</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item dense class="small-height">
            <v-list-item-avatar size="32">
              <v-icon class="grey lighten-2 grey--text">mdi-account</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                class="text-capitalize subtitle-2 font-weight-medium primary--text py-0 my-0"
                v-text="
                  selectedEvent.creator
                    ? selectedEvent.creator.first_name +
                      ' ' +
                      selectedEvent.creator.last_name
                    : 'no name'
                "
              ></v-list-item-title>
              <v-list-item-subtitle class="caption grey--text text--darken-3">
                <span id="organizer">Organizer‬</span>&nbsp;
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            dense
            class="small-height"
            v-for="participant in selectedEvent.participants"
            :key="participant.id"
          >
            <v-list-item-avatar size="32">
              <v-icon class="grey lighten-2 grey--text">mdi-account</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                class="text-capitalize subtitle-2 font-weight-medium primary--text mb-0"
                v-text="participant.first_name + ' ' + participant.last_name"
              ></v-list-item-title>
              <v-list-item-subtitle
                class="caption grey--text text--darken-3"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item dense class="small-height">
          <v-list-item-avatar>
            <v-icon>mdi-text</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="text-capitalize subtitle-2 font-weight-regular mb-0"
              v-text="selectedEvent.description"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item dense class="small-height">
          <v-list-item-avatar>
            <v-icon>mdi-bell-outline</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="subtitle-2 font-weight-regular mb-0"
              v-text="'10 minutes before'"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dense class="small-height">
          <v-list-item-avatar>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="subtitle-2 font-weight-regular mb-0">
              <a :href="`mailto:${selectedEvent.creator.email}`">{{
                selectedEvent.creator.email
              }}</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-1"></v-divider>
      </v-list>
      <v-toolbar fixed dense flat class="pa-0 ma-0 transparent">
        <span class="text-capitalize subtitle-2 font-weight-regular mb-0"
          >Reply?</span
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>
          <v-toolbar dense flat class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-btn class="text-capitalize" outlined rounded x-small>
              <span class="caption">Add Note</span>
            </v-btn>
          </v-toolbar>
        </div>
      </v-expand-transition>
    </v-card-text>
  </v-card>
  <!-- </v-menu> -->
</template>

<script>
// import calendarComp from '@/composition/schedule/calendar.composition'
import Vue from 'vue';

import dateFormat from '@/utils/dateFormat';

import {
  upperFirst
  //   findExistingIndex,
  //   filterDuplicates,
} from '@/utils/helpers';

// const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

export default Vue.extend({
  props: {
    // OBJECTS
    selectedEvent: {
      type: Object,
      default: () => {}
    },
    defaultEvent: {
      type: Object,
      default: () => {
        return {
          participants: []
        };
      }
    },
    clientEvent: {
      type: Object,
      default: () => ({})
    },
    // FUNCTIONS
    createEvent: {
      type: Function,
      default: () => {}
    },
    deleteEvent: {
      type: Function,
      default: () => {}
    },
    saveEvent: {
      type: Function,
      default: () => {}
    },
    closeCard: {
      type: Function,
      default: () => {}
    },
    routeTo: {
      type: Function,
      default: () => {}
    },
    selectedElement: {
      type: [HTMLDivElement, HTMLSpanElement, HTMLElement],
      default: null
    },
    // BOOLEANS
    selectedOpen: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    participants: [],
    searchParticipants: null,
    values: [{ id: '1', first_name: 'test name' }],
    // create
    type: 0,
    time: false,
    buttons: [
      {
        value: 0,
        icon: 'folder',
        text: 'Event'
      },
      {
        value: 1,
        icon: 'mdi-calendar',
        text: 'Schedule'
      },
      {
        value: 2,
        icon: 'mdi-folder',
        text: 'Reminder'
      }
    ],
    // DATA
    frequencyToLabel: {
      0: 'Yearly',
      1: 'Monthly',
      2: 'Weekly',
      3: 'Daily'
    },
    show: false,
    items: [
      {
        icon: 'mdi-solid',
        iconClass: 'lighten-1 primary--text',
        title: 'Schedule'
      },
      {
        icon: 'mdi-folder',
        iconClass: 'grey lighten-1 white--text',
        title: 'Reminder'
      },
      {
        icon: 'folder',
        iconClass: 'grey lighten-1 white--text',
        title: 'Event'
      }
    ]
  })
  //   setup(_, ctx) {
  //     const data = reactive({
  //       frequencyToLabel: {
  //         0: 'Yearly',
  //         1: 'Monthly',
  //         2: 'Weekly',
  //         3: 'Daily',
  //       },
  //       show: false,
  //       items: [
  //         {
  //           icon: 'mdi-solid',
  //           iconClass: 'lighten-1 primary--text',
  //           title: 'Schedule',
  //         },
  //         {
  //           icon: 'mdi-folder',
  //           iconClass: 'grey lighten-1 white--text',
  //           title: 'Reminder',
  //         },
  //         {
  //           icon: 'folder',
  //           iconClass: 'grey lighten-1 white--text',
  //           title: 'Event',
  //         },
  //       ],
  //     })

  //     const create = reactive({
  //       type: 0,
  //       time: false,
  //       buttons: [
  //         {
  //           value: 0,
  //           icon: 'folder',
  //           text: 'Event',
  //         },
  //         {
  //           value: 1,
  //           icon: 'mdi-calendar',
  //           text: 'Schedule',
  //         },
  //         {
  //           value: 2,
  //           icon: 'mdi-folder',
  //           text: 'Reminder',
  //         },
  //       ],
  //     })

  //     const apiData = reactive({
  //       participants: [],
  //       searchParticipants: null,
  //       values: [{ id: '1', first_name: 'test name' }],
  //     })
  //     const formatTime = (withTime, ampm) => {
  //       const suffix = ampm ? (withTime.hour < 12 ? 'a' : 'p') : ''
  //       const hour = withTime.hour % 12 || 12
  //       const minute = withTime.minute
  //       return minute > 0
  //         ? minute < 10
  //           ? `${hour}:0${minute}${suffix}`
  //           : `${hour}:${minute}${suffix}`
  //         : `${hour}${suffix}`
  //     }

  //     const getSeletedData = data => {
  //       // console.log(apiData.participants[0])
  //       console.log(_.defaultEvent)
  //       const duplicates = filterDuplicates(
  //         apiData.participants,
  //         data.id,
  //         data.first_name
  //       )
  //       console.log('duplicates', duplicates)

  //       const index = findExistingIndex(
  //         apiData.participants,
  //         data,
  //         data.id,
  //         data.first_name
  //       )
  //       console.log(apiData.participants[index])

  //       if (index > -1) {
  //         _.defaultEvent.participants.push(apiData.participants[index])
  //       }
  //       apiData.searchParticipants = null
  //     }
  //     onMounted(() => {
  //       // console.log('selectedEvent', _.selectedEvent)
  //       // console.log('defaultEvent', _.defaultEvent)
  //       // console.log('clientEvent', _.clientEvent)
  //     })

  //     onBeforeUpdate(() => {
  //       console.log('before updated!')
  //     })
  //     onUpdated(() => {
  //       console.log('updated!')
  //       // _.defaultEvent.participants = []
  //     })
  //     onBeforeUnmount(() => {
  //       console.log('onBeforeUnmount!')
  //       // _.defaultEvent.participants = []
  //     })
  //     const eventData = event => {
  //       console.log('EVENT', event)
  //     }
  //     // watch(
  //     //   () => _.closeCard,
  //     //   (pageName, prevName) => {
  //     //     console.log('WATCH DATA', pageName)
  //     //   }
  //     // )

  //     watch(
  //       () => apiData.searchParticipants,
  //       (participantsQuery, oldClients) => {
  //         console.log('WATCH DATA', participantsQuery)
  //         if (participantsQuery == null) return

  //         // Items have already been requested
  //         if (participantsQuery.trim().length >= 3) {
  //           searchCalendar(participantsQuery, 'user', 'id').then(res => {
  //             console.log('PARTS', res)
  //             apiData.participants = res
  //           })
  //           // clientQuery(participants)
  //         }
  //       }
  //     )
  //     const ICONS = {
  //       employee: 'mdi-calendar',
  //       user: 'mdi-account-circle',
  //       schedule: 'mdi-timer-sand',
  //       report: 'mdi-clipboard-text-outline',
  //     }
  //     const {
  //       // fetchCalendar,
  //       // fetchCalendars,
  //       // fetchCalendarEvent,
  //       // fetchCalendarEvents,
  //       // fetchCalendarOccurrence,
  //       // fetchCalendarOccurrences,
  //       // createCalendarInstance,
  //       // deleteCalendarOccurrence,
  //       // deleteCalendarEventInstance,
  //       // CALENDARS,
  //       // SET_CALENDAR_INSTANCE,
  //       // CALENDAR_INSTANCE,
  //       // CALENDARS_EVENTS,
  //       // CALENDARS_EVENTS_INSTANCE,
  //       // OCCURRENCES,
  //       searchCalendar,
  //     } = calendarComp()

  //     return {
  //       ...toRefs(data),
  //       ...toRefs(apiData),
  //       ...toRefs(create),
  //       dateFormat,
  //       upperFirst,
  //       formatTime,
  //       getSeletedData,
  //       ICONS,
  //       eventData,
  //     }
  //   },
});
</script>

<style>
.v-list-item--dense.small-height {
  min-height: 10px;
  height: 50px;
}
</style>
